<template>
  <div class="main main--signup-page">
    <sidebar-view></sidebar-view>
    <!--<overlay></overlay>-->
    <div class="auth__signup-container">
      <router-view/>
    </div>
  </div>
 
</template>

<style lang="scss">
  @import './../../assets/stylesheets/scss/auth';
</style>

<script>
  import SidebarView from '@/components/partials/SidebarView'
  
  export default {
    beforeCreate(){
      this.$store.commit('updateUserEmail', '');
      this.$store.commit('updateUserFirstName', '');
      this.$store.commit('updateUserLastName', '');
      this.$store.commit('updateUserAddress', '');
      this.$store.commit('updateUserCity', '');
      this.$store.commit('updateUserState', '');
      this.$store.commit('updatePassword', '');
      this.$store.commit('updateUserPhonenumber', '');
      this.$store.commit('updateSelectedCurrency', []);
      this.$store.commit('updateUserBusinessName', '');
      this.$store.commit('updateUserBusinessType', '');
      this.$store.commit('updateUserBusinessDescription', '');
    },
    data() {
      return {
      
      }
      
    },
    components:{
      'sidebar-view': SidebarView
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/onboarding/SignupBase.vue